import styled from 'styled-components'

const StyledEarnings = styled.div`
  .earning-metrics {
    .earning-table {
      position: relative;

      .table {
        margin-top: -12px;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 30%,
          ${({ theme }) => theme.colors.background}
        );
      }
    }

    .earning-metric {
      margin-left: auto;
      width: fit-content;
      display: block;
      margin-top: 20px;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[500]};

      b {
        font-size: 18px;
        font-weight: 400;
        margin-left: 8px;
        font-family: ${({ theme }) => theme.fonts.lexend};
        color: ${({ theme }) => theme.colors.gray[700]};
      }
    }
  }

  .skeleton-item {
    height: 229px;
    padding: 0;
  }
`

export default StyledEarnings
